import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from 'redux';
import userReducer from "../Slices/UserSlice";
import authReducer from "../Slices/AuthSlice";
import SchemeReducer from "../Slices/SchemeSlice";
import BeneficiaryReducer from "../Slices/BeneficiarySlice";
import InvoiceReducer from "../Slices/InvoiceSlice";
import PaymentInvoiceReducer from "../Slices/PaymentInvoiceSlice";
import DisbursmentInvoiceSlice from "../Slices/DisbursmentInvoiceSlice";
import departmentReducer from "../Slices/DepartmentSlice";
import appConfigReducer from "../Slices/AppConfigSlice";
    const persistConfig = {
        key: 'persistLocal',
        storage,
    };
  
  const rootReducer = combineReducers({
    user: userReducer,
    authData: authReducer,
    financialYears: authReducer,
    schemeData: SchemeReducer,
    beneficiaryData: BeneficiaryReducer,
    invoiceData: InvoiceReducer,
    payment_invoiceData: PaymentInvoiceReducer,
    disbursment_invoiceData: DisbursmentInvoiceSlice,
    department: departmentReducer,
    appConfig: appConfigReducer,
  });
  
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  
  export default persistedReducer;